import {useState} from 'react';

import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

import useEmmai from '../../../../../../../hooks/providers/useEmmai';
import DeletePractitionerConfirmModal from '../../../DeletePractitionerConfirmModal/DeletePractitionerConfirmModal';
import ToolbarIconButton from '../ToolbarIconButton/ToolbarIconButton';

const DeletePractitionerButton = () => {
  const {emmaiData, isPractitionerUpdating, deletePractitioner, selectedPractitionerId} = useEmmai();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const closeModal = () => setIsDeleteModalOpen(false);

  const handleDelete = async () => {
    closeModal();
    setIsDeleting(true);
    await deletePractitioner(selectedPractitionerId);
    setIsDeleting(false);
  };

  const disabled = isPractitionerUpdating || isDeleting;
  const practitioner = emmaiData.practitioners.find(p => p.practitioner_id === selectedPractitionerId) || {};

  return (
    <>
      <ToolbarIconButton onClick={() => setIsDeleteModalOpen(true)} disabled={disabled} edge="end" aria-label="supprimer praticien">
        <DeleteForeverOutlinedIcon color="error" sx={{fontSize: 12}} />
      </ToolbarIconButton>

      <DeletePractitionerConfirmModal isOpen={isDeleteModalOpen} onCancel={closeModal} onSubmit={handleDelete} practitioner={practitioner} />
    </>
  );
};

export default DeletePractitionerButton;
